// All style constants except typography should live here. Typography lives in ./utils/typography.js

export default {
	colors: {
		main: '#FF4511',
		mainDarker: '#c93311',
		secondary: '#001434',
		grayBack: '#F6F6F6',
		grayText: '#606060',
	},
	fontWeights: {
		regular: 400,
		medium: 500,
		bold: 700,
	},
	fontSizes: {
		extraSmall: '10px',
		smallest: '12px',
		small: '14px',
		big18: '18px',
		big20: '20px',
		big30: '30px',
		big40: '40px',
		big25: '25px',
	},

	transitions: {
		smallElements: '200ms',
	},
	siteWidth: '70rem',
	smallerWidth: '40rem',
}

